var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3337 13.5833V8.24992C13.3337 7.51352 12.7367 6.91659 12.0003 6.91659H11.167V4.24992C11.167 2.50385 9.74639 1.08325 8.00033 1.08325C6.25426 1.08325 4.83366 2.50385 4.83366 4.24992V6.91659H4.00033C3.26393 6.91659 2.66699 7.51352 2.66699 8.24992V13.5833C2.66699 14.3197 3.26393 14.9166 4.00033 14.9166H12.0003C12.7367 14.9166 13.3337 14.3197 13.3337 13.5833ZM10.167 6.91659H5.83366V4.24992C5.83366 3.05525 6.80566 2.08325 8.00033 2.08325C9.19499 2.08325 10.167 3.05525 10.167 4.24992V6.91659Z",
    fill: "#16162C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a3172ae219fd5dc3e92cc4bd14fca975.svg";
export { ForwardRef as ReactComponent };